import { Component, DOCUMENT, inject } from "@angular/core";

@Component({
  selector: "app-error-modal",
  standalone: true,
  imports: [],
  template: `
    <div
      class="modal modal-medium error-modal"
      data-testid="error-modal"
      role="alertdialog"
      aria-labelledby="error-modal-title"
      aria-describedby="error-modal-description"
    >
      <div class="modal-content error-modal__content">
        <div class="error-modal__message">
          <h3 id="error-modal-title" class="title-h4">Oups... petit souci!</h3>
          <p id="error-modal-description" class="body-2">On a rencontré un problème technique. Ce n'est pas de ta faute : on s'en occupe!</p>
        </div>
        <img class="error-modal__flo" src="assets/flo/flo-headscratch.svg" alt="Flo Headscratch" />
      </div>
      <div class="modal-actions">
        <button class="btn btn-secondary modal-action" (click)="handleClose()">Revenir au début de l'exercice</button>
      </div>
    </div>
  `,
  styles: `
    @use "responsive" as *;

    .error-modal {
      height: 480px;
    }

    .error-modal__content {
      position: relative;
      height: 376px;
      padding-top: 0;
      padding-bottom: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background-color: #94dbfe;
    }

    .error-modal__flo {
      display: block;
      width: 100%;
      max-width: 380px;
      margin-top: auto;
    }

    .error-modal__message {
      position: absolute;
      top: 56px;
      left: 0;
      right: 0;
      padding: 0 24px;
      text-align: center;
      > * {
        text-align: center;
      }

      h3 {
        margin-bottom: 16px;
      }

      p {
        max-width: 400px;
        margin: 0 auto;
      }
    }
  `,
})
export class ErrorModal {
  private document: Document = inject(DOCUMENT);

  protected handleClose() {
    this.document.defaultView?.location.reload();
  }
}
